import { t } from '@lingui/core/macro';
import { IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useScreenLayout } from './ScreenLayoutProvider';
export function SidebarToggleButton() {
    const { sidebar } = useScreenLayout();
    return (<IconButton appearance="secondary" size="xs" onClick={sidebar.toggle} aria-label={t({
            message: 'Toggle sidebar menu',
            comment: 'Global PLAI: Toggle sidebar menu button',
        })}>
      <Falcon icon="sidebar-flip"/>
    </IconButton>);
}
